// extracted by mini-css-extract-plugin
export default {"button":"WhatsAppOnTop_button__ASXY1","rotatedArrow":"WhatsAppOnTop_rotatedArrow__LApR-","contacticonForwp":"WhatsAppOnTop_contacticonForwp__WgjmC"};